import request from "../web-sh/src/utils/request";
import global from "../config/global";

async function get_payments(params = {}) {
  return request({
    url: global.endpoint.PAYMENTS,
    method: "get",
    params
  });
}

async function get_payments_plan(params = {}) {
  return request({
    url: global.endpoint.PAYMENTS_PLAN,
    method: "get",
    params
  });
}

async function get_payments_plan_limit(params = {}) {
  return request({
    url: global.endpoint.PAYMENTS_PLAN_LIMIT,
    method: "get",
    params
  });
}

async function cancel_plan(data = {}) {
  return request({
    url: global.endpoint.PAYMENTS_PLAN_CANCEL,
    method: "post",
    data
  });
}

async function trial(data = {}) {
  return request({
    url: global.endpoint.PAYMENTS_TRIAL,
    method: "post",
    data
  });
}

async function get_payments_cards(params = {}) {
  return request({
    url: global.endpoint.PAYMENTS_CARDS,
    method: "get",
    params
  });
}

async function calc(data = {}) {
  return request({
    url: global.endpoint.PAYMENTS_CALC,
    method: "post",
    data
  });
}

async function add_payments_card(data = {}) {
  return request({
    url: global.endpoint.PAYMENTS_CARDS,
    method: "post",
    data
  });
}

async function update_payments_card(id, data = {}) {
  return request({
    url: global.endpoint.PAYMENTS_CARD_DETAIL.replace(':id', id),
    method: "put",
    data
  });
}

async function remove_payments_card(id) {
  return request({
    url: global.endpoint.PAYMENTS_CARD.replace(':id', id),
    method: "delete",
  });
}

async function create_plan(data = {}) {
  return request({
    url: global.endpoint.PAYMENTS_PLAN,
    method: "post",
    data
  });
}

async function get_payments_invoices(params = {}) {
  return request({
    url: global.endpoint.PAYMENTS_INVOICES,
    method: "get",
    params
  });
}

export default {
  get_payments,
  get_payments_plan,
  get_payments_plan_limit,
  cancel_plan,
  trial,
  get_payments_cards,
  calc,
  add_payments_card,
  update_payments_card,
  remove_payments_card,
  create_plan,
  get_payments_invoices
};
